
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import TicketPriorityIcon from "@/inspection/ticket/widgets/TicketPriorityIcon.vue";

import { Ticket } from "@/inspection/shared/models/Ticket";

@Component<TicketCard>({
  components: { TicketPriorityIcon }
})
export default class TicketCard extends Vue {
  @Prop({ type: Object, default: () => new Ticket() })
  protected readonly ticket!: Ticket;

  @Prop({ type: Boolean, default: true })
  protected readonly clickable!: boolean;

  @Prop({ type: Boolean, default: false })
  protected readonly compact!: boolean;

  protected get compactDescription(): string {
    return (this.ticket.description ?? "").replace(/\s+/g, " ").trim();
  }

  protected ticketClicked() {
    if (this.clickable) {
      this.$emit("click");
    }
  }
}
